/*
 * 【必须】 套件依赖的store，“必须”在项目store中导入
 * import { store as CommonsStore } from 'commons'
 * import store from 'commons/store'
 */
import Controlor from './Controlor'

const state = {
  cartList: [],
  messageList: [],
  openShopModal: false,
  ...Controlor.state
}

const mutations = {
  getCartList(state) {
    global.$ComAxios.get(global.$ComDomain.Params.list, { params: { customStatus: 0 } })
      .then(response => {
        if (response.status == 200 && response.data.status == 200) {
          state.cartList = response.data.params
        }
      })
      .catch(() => {})
  },
  getMessageList(state) {
    global.$ComAxios.get(global.$ComDomain.Message.list, { params: { limit: 10000 } })
      .then(response => {
        if (response.status == 200 && response.data.status == 200) {
          state.messageList = response.data.result.list
        }
      })
      .catch(() => {})
  },
  service(state, { type }) {
    switch (type) {
      case 'QQ':
        window.open('http://wpa.qq.com/msgrd?v=3&uin=2067511391&site=qq&menu=yes', '_blank', 'height=502, width=644,toolbar=no,scrollbars=no,menubar=no,status=no')
        break
    }
  },
  ...Controlor.mutations
}

const actions = {
  ...Controlor.actions
}

const getters = {
  ...Controlor.getters
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/commons/store/index.js